import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Sabés evaluar pero no sabés cómo fijar honorarios, manejar cancelaciones ni estructurar tu semana sin agotarte.',
  good: 'Sistema completo de gestión del consultorio: calculadora de honorarios, acuerdo de inicio, política de cancelaciones, estructura de agenda y guión de aumento de precios.'
}, {
  bad: 'Tenés Instagram pero no sabés qué publicar ni cómo conseguir que los pediatras te deriven pacientes.',
  good: 'Calendario de 30 días de contenido para Instagram, guión de presentación ante pediatras y las 5 formas más efectivas de conseguir pacientes sin publicidad paga.'
}];
const includedTomos = [{
  id: 'T7',
  title: 'Cómo Armar y Gestionar tu Consultorio Privado desde Cero',
  desc: 'Honorarios, cancelaciones, agenda y acuerdo de inicio — todo por escrito desde el día uno.',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=160&h=160&q=70&fit=crop&auto=format',
  alt: 'Gestión administrativa del consultorio privado'
}, {
  id: 'T8',
  title: 'Cómo Comunicar tu Trabajo en Redes y Conseguir tus Primeros Pacientes',
  desc: 'Instagram, derivaciones con pediatras, charlas en escuelas y Google My Business — el sistema completo para llenar el consultorio sin publicidad paga.',
  image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=160&h=160&q=70&fit=crop&auto=format',
  alt: 'Comunicación profesional en redes sociales'
}];
export function EditionCompleta() {
  return <section className="py-12 md:py-20 px-4 md:px-8 bg-white" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <SectionHeader title="¿QUÉ AGREGA LA EDICIÓN COMPLETA?" subtitle="Para fonoaudiólogas que quieren el consultorio resuelto además de la evaluación" className="mb-8 md:mb-12" data-id="element-74" />

        <div className="space-y-4 md:space-y-6 mb-10 md:mb-16" data-id="element-75">
          {comparisons.map((item, index) => <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-76">
              <div className="bg-slate-50 p-4 md:p-6 rounded-xl md:rounded-2xl border border-slate-200" data-id="element-77">
                <div className="flex items-center gap-2 text-slate-500 font-bold text-xs md:text-sm uppercase tracking-wider mb-2 md:mb-3" data-id="element-78">
                  <XIcon size={14} data-id="element-79" /> Sin Edición Completa
                </div>
                <p className="text-sm md:text-base text-slate-600 leading-relaxed" data-id="element-80">
                  {item.bad}
                </p>
              </div>
              <div className="bg-teal-50 p-4 md:p-6 rounded-xl md:rounded-2xl border border-teal-200 shadow-sm" data-id="element-81">
                <div className="flex items-center gap-2 text-teal-800 font-bold text-xs md:text-sm uppercase tracking-wider mb-2 md:mb-3" data-id="element-82">
                  <CheckIcon size={14} data-id="element-83" /> Con Edición Completa
                </div>
                <p className="text-sm md:text-base text-teal-900 font-medium leading-relaxed" data-id="element-84">
                  {item.good}
                </p>
              </div>
            </div>)}
        </div>

        {/* Includes block — horizontal compact rows with images */}
        <div data-id="element-85">
          <h3 className="text-xs md:text-sm font-bold text-teal-700 uppercase tracking-widest mb-4 md:mb-6 text-center" data-id="element-86">
            LA EDICIÓN COMPLETA INCLUYE:
          </h3>

          <div className="bg-white rounded-2xl md:rounded-3xl border border-slate-200 shadow-sm overflow-hidden divide-y divide-slate-100" data-id="element-87">
            {includedTomos.map((tomo, index) => <motion.div key={tomo.id} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-30px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.08
          }} className="flex items-start gap-3 md:gap-5 p-3 md:p-5 hover:bg-cream/40 transition-colors" data-id="element-88">
                {/* Image thumbnail */}
                <div className="shrink-0 relative" data-id="element-89">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden bg-teal-50 border border-slate-200" data-id="element-90">
                    <img src={tomo.image} alt={tomo.alt} width="80" height="80" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-91" />
                  </div>
                  <span className="absolute -top-1.5 -left-1.5 bg-teal-900 text-white font-bold text-[10px] md:text-xs px-1.5 py-0.5 rounded shadow uppercase tracking-wider" data-id="element-92">
                    {tomo.id}
                  </span>
                </div>

                {/* Content */}
                <div className="flex-grow min-w-0 pt-0.5" data-id="element-93">
                  <h4 className="font-bold text-black mb-1 md:mb-1.5 leading-tight text-sm md:text-base font-serif" data-id="element-94">
                    {tomo.title}
                  </h4>
                  <p className="text-xs md:text-sm text-slate-600 leading-relaxed" data-id="element-95">
                    {tomo.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}